import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";

function RewardModal(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
    >
      <Modal.Body className="bg-default rounded-4">
        <div className="d-flex justify-content-end">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="currentColor"
            className="bi bi-x-lg"
            viewBox="0 0 16 16"
            onClick={props.onHide}
            aria-label="Close"
            style={{ cursor: "pointer" }}
          >
            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
          </svg>
        </div>
        <Container>
          <Row>
            <Col md={12} lg={12} className="mb-4">
              <div className="d-flex align-items-center justify-content-center gap-2">
                <img
                  src="\media\assets\events\reward.png"
                  alt="reward"
                  width={35}
                  height={35}
                />
                <div className="fs-2 fw-bold">Exclusive rewards</div>
                <img
                  src="\media\assets\events\reward.png"
                  alt="reward"
                  width={35}
                  height={35}
                />
              </div>
            </Col>
            <Col md={12} lg={12}>
              {props.rewardText ? (
                <p className="fs-6">{props.rewardText}</p>
              ) : (
                <p className="fs-4 text-center">No rewards</p>
              )}
            </Col>
          </Row>
        </Container>
      </Modal.Body>
    </Modal>
  );
}

export default RewardModal;
